import styled from 'styled-components'

const MainContainer = styled.form<{
  ref: React.RefObject<HTMLFormElement>
}>`
  position: relative;
  top: 0;
  right: 0;
  padding: 0;
  width: 180px;
  max-width: 100%;
  .input-container {
    display: flex;
    height: 48px;
    position: relative;
    padding-left: 10px;
    display: flex;
    gap: 7px;
    max-width: 180px;

    align-items: center;
    border: 1px solid rgb(28, 29, 34);
    border-radius: 5px;
    transition: all 0.3s ease-out;
  }
  .doc {
    width: 16px;
    height: 16px;
  }
  .chrevon-down {
    width: 16px;
    height: 16px;
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    pointer-events: none;
  }
`

const FakeInput = styled.span`
  font-family: Inter;
  font-weight: 500;
  font-size: 12px;
  color: #757575;
`

const Placeholder = styled.span<{ $isValid: boolean }>`
  position: absolute;
  top: 50%;
  transform: translate(0%, -50%);
  left: 40px;
  font-family: Inter;
  font-weight: 500;
  font-size: 14px;
  color: #757575;
  display: ${(props) => (props.$isValid ? 'none' : 'flex')};
`

const Menu = styled.div`
  display: flex;
  flex-direction: column;
  width: 180px;
  border-radius: 4px;
  position: absolute;
  top: 56px;
  z-index: 99;
  background-color: #fff;
  .option {
    transition: all 0.3s ease;
    cursor: pointer;
    outline: none;
    border: none;
    color: #333333;
    text-align: left;
    background-color: #fff;
    padding: 8px 10px;
    font-size: 12px;
    color: #1c1d22;
    font-weight: 500;
    background-color: #fff;
  }
  .option:hover {
    background-color: #e0e0e0;
  }
  .selected {
    background-color: #e0e0e0;
  }
  .selected:hover {
    background-color: #e0e0e0;
  }
`

export { MainContainer, FakeInput, Placeholder, Menu }
